import { useEffect } from 'react';
import { lockBodyScroll, unlockBodyScroll } from '../helpers/bodyScrollLock';

function useBodyScrollLock(shouldLock: boolean): void {
  useEffect(() => {
    if (shouldLock) {
      lockBodyScroll();
    }
    return (): void => {
      unlockBodyScroll();
    };
  }, [shouldLock]);
}

export default useBodyScrollLock;
